
import { ref } from "vue";
import { Player } from "types/player";

import { GameConfigObj, GameItem } from "types/gameSession";
import { useToast } from "vue-toastification";

type inputNames = 'gameName' | 'players'

export const useSubmitGameForm = (gameConfig: GameConfigObj) => {

    const toast = useToast();

    const gameName = ref<GameItem | undefined>(undefined);
    const players = ref<Player[] | []>([])


    const onTagSelection = ({ playersOrder }: { playersOrder: Player[] }) => {
        players.value = [];
        players.value = [...playersOrder]
    }


    const validateInputs = () => {
        if (!gameName.value || players.value.length === 0)
            return toast.error('Missing Inputs')


        const minPLayers = gameConfig[gameName.value.id].minPlayers
        const maxPlayers = gameConfig[gameName.value.id].maxPlayers

        if (players.value.length < minPLayers || players.value.length > maxPlayers)
            return toast.error('Wrong number of players');

        return {
            gameName: gameName.value.id,
            playersOrder: [...players.value]
        };
    };

    return {
        gameName,
        players,
        validateInputs,
        onTagSelection
    };
};